<template>
  <div :class="['mod-Scity', status ? 'active' : '']" @click.stop>
    <div :class="['area-input', 'font-boder-defalut-color', status ? 'font-boder-hover-defalut-color' : '', disable ? 'area-input-disable font-color-disable' :'']" @click="!disable && changeStatus()">
      <!-- <input type="text" value="请输入地址" /> -->
      <template v-if="!isHome">
        <p class="placeholder font-color-placeholder" v-if="!selected.status">{{placeholder}}</p>
        <p class="selected" v-else :title="selected.value">{{selected.value}}</p>
        <i :class="['area-icon-arrow font-boder-hover-defalut-color', status ? 'active' : '']"></i>
      </template>
      <template v-else>
        <p class="placeholder font-color-placeholder" v-if="!selected.status">{{placeholder}}</p>
        <p class="selected font-color-hover-primary" v-else :title="selected.value">
          {{selected.value}}
          <i class="triangle"></i>
        </p>
      </template>
    </div>
    <div class="area-content" v-if="status">
      <ul class="area-option yug">
        <li
          v-for="item in tabsList" :key="item" :style="{width:  100 / tabsList.length + '%'}"
          @click="options[item].list.length > 0 && clickTabItem(item)"
          :class='{"active": item === activeSelect, "disable": options[item].list.length === 0}'
        >
          {{options[item].name}}
        </li>
      </ul>

      <template v-if="options[activeSelect].status === 'success'">
        <template v-if="options[activeSelect].list.length">
          <ul class="area-list syue-clr">
            <li
              v-for="(item, index) in options[activeSelect].list"
              @click="handleClickItem(item, index)"
              :key="item.cityCode + item.name"
              :title="item.name"
              :class="[
                'area-item',
                'font-color-hover-primary',
                item.cityCode === (selected.data[options[activeSelect].code] && selected.data[options[activeSelect].code].cityCode)
                  ? 'active font-color-primary'
                  : ''
              ]"
            >
              {{item.name}}
            </li>
          </ul>
          <p v-if="clearable" class="clear-select"><span @click="clearAll" class="font-color-hover-primary">{{pageText.empty}}</span></p>
        </template>
        <template v-else>
          <p class="no-data">{{pageText.noData}}</p>
        </template>
      </template>
      <template v-else-if="options[activeSelect].status === 'loading'">
        <div class="area-loading font-color-primary">
            <i class="icon-loading">
              <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
            </i>
            <span class="font-color-text">{{pageText.dataLoading}}</span>
        </div>
      </template>
      <template v-else-if="options[activeSelect].status === 'error'">
        <div class="area-load-error">
          <span>{{pageText.loadFail}}</span>
          <em
            @click="againLoad"
            class="font-color-primary-hover"
          >{{pageText.retry}}</em>
        </div>
      </template>
    </div>
  </div>
</template>
<style lang="less" >
  @keyframes loading-rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes loading-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40px;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -120px;
    }
  }
  .mod-Scity{
    width: 100%;
    position: relative;
    &.active{
      z-index: 10;
    }
    .no-data{
      text-align: center;
    }
    .area-load-error{
      text-align: center;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
      em{
        cursor: pointer;
      }
    }
    .area-loading{
      text-align: center;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
      span{
        display: inline-block;
        vertical-align: middle;
      }
      .icon-loading{
        width: 16px;
        height: 16px;
        vertical-align: middle;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        top: 3px;
        .circular {
          height: 16px;
          width: 16px;
          animation: loading-rotate 2s linear infinite;
        }
        .path {
          animation: loading-dash 1.5s ease-in-out infinite;
          stroke-dasharray: 90,150;
          stroke-dashoffset: 0;
          stroke-width: 2;
          stroke: currentColor;
          stroke-linecap: round;
        }
      }
    }
    .area-input {
      width: 100%;
      height: 30px;
      font-size: 12px;
      line-height: 30px;
      box-sizing: border-box;
      border: 1px solid currentColor;
      position: relative;
      .placeholder{
        padding: 0 15px;
        overflow: hidden;
        text-overflow:ellipsis;
      }
      &.area-input-disable{
        cursor: no-drop;
        .selected {
          color: #d3d3d3;
        }
      }
      .selected {
        color: #666;
        padding: 0 15px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .area-icon-arrow{
        width: 30px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transition: transform 0.3s;
        transform: rotate(180deg);
        &.active{
          transform: rotate(0deg);
        }
        &:before{
          content: '\20';
          width: 0px;
          height: 0px;
          position: absolute;
          top: 5px;
          left: 10px;
          border: 6px solid transparent;
          border-bottom-color: currentColor;
        }
        &:after {
          content: '\20';
          width: 0px;
          height: 0px;
          position: absolute;
          border: 6px solid transparent;
          border-bottom-color: #fff;
          top: 6px;
          left: 10px;
        }
      }
      .triangle{
        position: absolute;
        // right: -6px;
        top: 12px;
        margin-left: 6px;
        display: inline-block;
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid currentColor;
      }
    }
    .area-content{
      border: 1px solid #ccc;
      position: absolute;
      background: #fff;
      box-sizing: border-box;
      top: 29px;
      left: 0px;
      width: 100%;
      .area-option{
        overflow: hidden;
        background: #f5f5f5;
        li{
          float: left;
          width: 25%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
          box-sizing: border-box;
          border-bottom: 1px solid #e5e5e5;
          + li {
            border-left: 1px solid #e5e5e5;
          }
          &.active{
            background: #fff;
            border-bottom: 1px solid #fff;
            cursor: default;
          }
        }
      }
      .area-list{
        padding: 10px 10px 10px 10px;
        .area-item{
          width: 50px;
          display: inline-block;
          vertical-align: middle;
          font-size: 12px;
          margin-right: 15px;
          margin-left: 15px;
          line-height: 28px;
          overflow: hidden;
          height: 28px;
          cursor: pointer;
        }
      }
      .clear-select{
        text-align: center;
        padding-bottom: 4px;
        span{
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }
</style>

<script>
/* eslint-disable no-new */
import api from './api.js'
import i18n from './i18n.js'
// let moduleI18n =
const TABS = 'pcas'
const pageText = i18n['zh-CN']
// console.log(pageText)
export default {
  props: {
    // 选择table
    optionalTabs: {
      type: String,
      default: 'pca'
    },
    // 标签文案
    tabLabel: {
      type: Array
    },
    // 是否有清空
    clearable: {
      type: Boolean,
      default: true
    },
    // placeholder
    placeholder: {
      type: String,
      default: pageText.placeholder
    },
    // 禁用
    disable: {
      type: Boolean,
      default: false
    },
    // 分割符
    separator: {
      type: String,
      default: '/'
    },
    // 如果不是省级选择需要传id
    id: {
      type: String
    },
    // 反显数据
    data: {
      type: Object
    },
    // 是否是首页顶部所用
    isHome: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const tabsList = this.optionalTabs.toLowerCase().split('')
    const selected = {
      // 是否选中
      status: false,
      data: {
        province: {},
        city: {},
        area: {},
        street: {}
      },
      value: ''
    }
    return {
      pageText: pageText,
      status: false, // 用来判断 展示隐藏
      // 地区数据
      areaData: [],
      // 当前选中的tab
      activeSelect: tabsList[0],
      // 当前可选标签
      tabsList: tabsList,
      // 所有可选标签
      tabs: TABS,
      // tab选项数据
      options: {
        p: {
          name: pageText.province,
          nextLevelName: 'c', // 下一级的name
          code: 'province', // 当前选择的code
          index: '', // 选择的索引
          list: [], // 存放数据
          cityCode: '', // 当前选择的id
          status: 'loading' // loading：加载中  error：加载失败 success: 加载成功
        },
        c: {
          name: pageText.city,
          nextLevelName: 'a',
          code: 'city',
          index: '',
          cityCode: '',
          list: [],
          status: 'loading'
        },
        a: {
          name: pageText.area,
          nextLevelName: 's',
          code: 'area',
          index: '',
          list: [],
          cityCode: '',
          status: 'loading'
        },
        s: {
          name: pageText.street,
          code: 'street',
          index: '',
          cityCode: '',
          list: [],
          status: 'loading'
        }
      },
      // 选中数据
      selected: selected
    }
  },
  watch: {
    data: function (newData, oldData) {
      const newArea = this.getShowArea(newData)
      const oldArea = this.getShowArea(oldData)
      // console.log(newArea, oldArea)
      // console.log(newArea === oldArea)
      if (newArea !== oldArea) {
        this.initSelected(newData)
      }
    }
  },
  async created () {
    // 如果props没有问题
    if (this.init()) {
      // console.log(this.data)
      await this.getData(this.tabsList[0], this.areaData)
      // console.log('data')
      this.initSelected(this.data)
    }
  },
  mounted () {
    let vm = this
    document.addEventListener('click', function () {
      vm.status = false
    })
  },
  methods: {
    // 主要用来判断 props数据是否正确
    init () {
      const optionalTabs = this.optionalTabs.toLowerCase()
      const tabLabel = this.tabLabel
      // 判读tab顺序是否正常
      if (TABS.indexOf(optionalTabs) === -1) {
        new Error('optionalTabs 顺序异常')
        return false
      }
      // 判断lable长度是否和tab长度一致
      if (tabLabel && tabLabel.length !== optionalTabs.length) {
        new Error('tabLabel 和 optional 长度不匹配')
        return false
      }
      return true
    },
    // 初始化选中数据
    initSelected (obj) {
      const tabsList = this.tabsList
      const options = this.options
      const selected = this.selected
      const data = obj || {}
      let value = ''
      // 如果没有
      if (obj) {
        for (let i = 0; i < tabsList.length; i++) {
          const tab = options[tabsList[i]]
          const tabCode = tab.code
          const dataCode = data[tabCode].code
          const dataName = data[tabCode].name
          const isMunicipality = this.isMunicipality(tabCode, dataName)
          if (data[tabCode] && dataCode && !isMunicipality) {
            data[tabCode].cityCode = dataCode
            value += (i !== 0 ? this.separator : '') + dataName
          }
        }
      } else {
        for (let i = 0; i < tabsList.length; i++) {
          const key = options[tabsList[i]].code
          data[key] = {}
        }
      }
      selected.status = !!obj
      selected.value = value
      selected.data = data
      obj && this.requestSelectData(data)
    },
    async requestSelectData (data) {
      const tabsList = this.tabsList
      const options = this.options
      // const areaData = this.areaData
      for (let i = 0; i < tabsList.length - 1; i++) {
        const tab = options[tabsList[i]]
        const code = tab.code
        if (data[code]) {
          for (let z = 0; z < tab.list.length; z++) {
            // console.log(tab.list[z].name)
            if (data[code].name === tab.list[z].name) {
              tab.index = z
              await this.getData(tabsList[i + 1], tab.list[z])
              break
            }
          }
          // await getData(tabsList[i], )
        }
      }
      // for (var i=)
      // console.log(data, this.areaData, tabsList, options)
    },
    // 修改组件状态 是否显示
    changeStatus (bool) {
      if (bool !== undefined) {
        this.status = bool
      } else {
        this.status = !this.status
      }
    },
    // 请求省列表
    getProvince () {
      const listApi = api.list
      const promise = this.$http(listApi.type, listApi.url)
      return promise
    },
    // 请求某个地区下的数据
    getArea (item) {
      const getApi = api.get
      const cityCode = (item && item.cityCode) || this.cityCode
      const promise = this.$http(getApi.type, getApi.url, {
        id: cityCode
      })
      return promise
    },
    async getData (tab, item) {
      const self = this
      self.options[tab].status = 'loading'
      let promise = null
      if (tab === 'p') {
        promise = this.getProvince()
      } else {
        promise = this.getArea(item)
      }
      await self.handleResponse(promise, item, tab)
    },
    // 处理请求响应
    async handleResponse (promise, item, tab) {
      const self = this
      await promise.then(res => {
        const data = res.data
        if (data.success) {
          self.options[tab].list = data.content
          self.options[tab].status = 'success'
          if (item !== self.areaData) {
            // console.log(data.content.length)
            item.children = data.content
            if (data.content.length <= 0) {
              this.handleSelected()
              // this.activeSelect = tab
              // this.options[tab].cityCode = item.cityCode
            }
          } else {
            self.areaData = data.content
          }
        } else {
          self.options[tab].status = 'error'
        }
        // console.log(res)
      })
        .catch(() => {
          self.options[tab].status = 'error'
        })
    },
    // 点击某项区域
    handleClickItem (item, index) {
      const activeSelect = this.activeSelect
      this.clearOuterTab()
      this.options[activeSelect].index = index
      if (this.hasNextLevel(item)) {
        const tab = this.options[activeSelect].nextLevelName
        // 修改当前的值
        this.activeSelect = tab
        this.options[tab].cityCode = item.cityCode
        if (!item.children) {
          this.getData(tab, item)
          // console.log(this.options[tab].list)
        } else {
          this.options[tab].list = item.children
          this.options[tab].status = 'success'
        }
      } else {
        // 选择完成
        // console && console.log('完成')
        this.handleSelected()
      }
    },
    // 选中
    handleSelected () {
      const selected = this.selected
      const tabsList = this.tabsList
      let areaData = this.areaData
      const data = {}
      let value = ''
      // 循环可选标签
      for (let i = 0; i < tabsList.length; i++) {
        const tab = this.options[tabsList[i]]
        let obj = {}
        if (areaData && areaData.length) {
          obj = Object.assign({}, areaData[tab.index])
          areaData = areaData[tab.index].children || []
          // 删除不需要的属性
          delete obj.children
          data[tab.code] = obj
          // 后端给的字段是citycode 输出的时候增加一个code 字段 保证输入和输出一致
          data[tab.code].code = obj.cityCode
          // 拼接显示字符串 如果是最后一项 不加分隔符
          const isMunicipality = this.isMunicipality(tab.code, obj.name)
          if (!isMunicipality) {
            value += (i !== 0 ? this.separator : '') + obj.name
          }
        } else {
          areaData = []
        }
      }
      selected.data = data
      selected.value = value
      selected.status = true
      // 关闭复层
      this.changeStatus(false)
      // 通知父组件
      this.$emit('input', data)
    },
    // 清除后面选的值
    clearOuterTab () {
      const activeSelect = this.options[this.activeSelect].nextLevelName
      const index = this.optionalTabs.indexOf(activeSelect)
      const tabsList = this.tabsList
      if (index !== -1) {
        for (let i = index; i < tabsList.length; i++) {
          this.options[tabsList[i]].list = []
        }
      }
    },
    // 是否是直辖市
    isMunicipality (tabCode, name) {
      let municipality = ['北京', '天津', '上海', '重庆'] // 天津、北京、上海、重庆
      if (tabCode === 'city' && name) {
        return municipality.some((item) => {
          return name.substring(0, 2) === item
        })
      }
      return false
    },
    // 是否有下一级
    hasNextLevel (item) {
      const activeSelect = this.activeSelect
      const hasNextLevel = this.options[activeSelect].nextLevelName
      if (this.optionalTabs.indexOf(hasNextLevel) !== -1) {
        if (item.children && item.children.length === 0) {
          return false
        }
        return true
      } else {
        return false
      }
    },
    // 切换tab
    clickTabItem (tab) {
      // 没有数据不能切换
      this.activeSelect = tab
    },
    // 清除选择
    clearAll () {
      this.activeSelect = this.tabsList[0]
      this.clearOuterTab()
      this.initSelected()
      this.$emit('clearAll')
    },
    // 重新加载
    againLoad () {
      const activeSelect = this.activeSelect
      let item = null
      const index = this.optionalTabs.indexOf(activeSelect) - 1
      if (index >= 0) {
        let tab = this.options[this.tabsList[index]]
        item = tab.list[tab.index]
      } else {
        item = this.areaData
      }
      this.getData(activeSelect, item)
    },
    // 获取展示地址
    getShowArea (data) {
      if (data === null) {
        return ''
      }
      let value = ''
      const tabsList = this.tabsList
      // 循环可选标签
      for (let i = 0; i < tabsList.length; i++) {
        const tab = this.options[tabsList[i]].code
        let obj = {}
        if (data[tab] && data[tab].name) {
          obj = data[tab]
          // 拼接显示字符串 如果是最后一项 不加分隔符
          value += (i !== 0 ? this.separator : '') + obj.name
        } else {
          break
        }
      }
      return value
    },
    // 获取选择数据
    getValue () {
      return this.selected.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vue-area/scity.vue